import { ControlIcons } from 'owa-control-icons';
import { createLinkPreviewBorder } from './BaseLinkPreviewObject';
import { BaseLinkPreviewObject, LinkPreviewType } from './BaseLinkPreviewObject';
import * as Constants from './constants';
import { PreviewSize } from './updatePreviewSize';
import {
    createDomElementsForWebpageLinkPreview,
    rehydrateWebPageLinkPreview,
    updateWebpageLinkPreviewSize,
    WebpageLinkPreviewObject,
} from './WebpageLinkPreviewObject';
import showVideoPlayer from '../components/BingVideoPlayer';
import getLinkPreview from '../services/getLinkPreview';
import { getIconClassName } from '@uifabric/styling/lib/index';
import BingVideoLinkPreview from 'owa-service/lib/contract/BingVideoLinkPreview';
import GetLinkPreviewResponse from 'owa-service/lib/contract/GetLinkPreviewResponse';

let videoPlayerStyles = require('../styles/videoPlayerStyles.scss');
const classNames = require('classnames/bind');
const REHYDRATE_ID = 'rehydrate';

export interface VideoLinkPreviewObject extends WebpageLinkPreviewObject {
    videoUrl: string;
    videoPlayer: string;
    motionThumbnail?: string;

    playVideoButtonContainer?: HTMLDivElement;
}

export function createVideoLinkPreviewObject(
    linkPreview: BingVideoLinkPreview,
    anchor: HTMLAnchorElement,
    inCompose: boolean
): VideoLinkPreviewObject {
    let lp: VideoLinkPreviewObject = {
        type: LinkPreviewType.VideoPreview,
        description: linkPreview.Description,
        title: linkPreview.Title,
        url: linkPreview.Url,
        thumbnailImageUrl: linkPreview.ImageUrl,
        anchor: anchor,
        videoUrl: linkPreview.Url,
        videoPlayer: linkPreview.EmbeddedHtml,
        motionThumbnail: linkPreview.MotionThumbnailUrl,
    };

    // For now, just use the exact same style as the webpage link previews.
    createLinkPreviewBorder(Constants.LINK_PREVIEW_BORDER_VIDEO_TYPE, lp);
    createDomElementsForWebpageLinkPreview(lp, inCompose);

    return lp;
}

export async function rehydrateVideoLinkPreview(
    div: HTMLDivElement
): Promise<BaseLinkPreviewObject> {
    let linkPreviewObject = <VideoLinkPreviewObject>await rehydrateWebPageLinkPreview(div);
    linkPreviewObject.type = LinkPreviewType.VideoPreview;
    linkPreviewObject.videoUrl = linkPreviewObject.url;
    linkPreviewObject.videoPlayer = null;
    linkPreviewObject.motionThumbnail = null;
    linkPreviewObject.playVideoButtonContainer = null;

    // The relative position property on the image container may have been stripped after sent, and it is needed to ensure
    // that the play button is positioned properly, so add it back now
    if (linkPreviewObject.thumbnailImageContainer) {
        linkPreviewObject.thumbnailImageContainer.style.position = 'relative';
    }

    return getLinkPreview(linkPreviewObject.videoUrl, REHYDRATE_ID).then(
        (response: GetLinkPreviewResponse) => {
            if (response.LinkPreview.__type == Constants.BING_VIDEO_LINK_PREVIEW_TYPE) {
                linkPreviewObject.videoPlayer = (<BingVideoLinkPreview>(
                    response.LinkPreview
                )).EmbeddedHtml;
            }

            return linkPreviewObject;
        }
    );
}

export function addPlayButton(lp: VideoLinkPreviewObject) {
    let playButtonIcon = document.createElement('span');
    playButtonIcon.className = classNames([
        videoPlayerStyles.playButtonIcon,
        getIconClassName(ControlIcons.Play),
    ]);
    lp.playVideoButtonContainer = document.createElement('div');
    lp.playVideoButtonContainer.className = videoPlayerStyles.playButtonContainer;
    lp.playVideoButtonContainer.appendChild(playButtonIcon);

    lp.thumbnailImageContainer.onclick = function(this: HTMLElement, evt: MouseEvent): any {
        evt.stopPropagation();
        if (lp.videoPlayer) {
            showVideoPlayer(lp.videoPlayer);
        }
        return false;
    };

    lp.thumbnailImageContainer.appendChild(
        document.createComment(Constants.COMPOSE_ONLY_CONTENT_START)
    );
    lp.thumbnailImageContainer.appendChild(lp.playVideoButtonContainer);
    lp.thumbnailImageContainer.appendChild(
        document.createComment(Constants.COMPOSE_ONLY_CONTENT_END)
    );
}

export function updateVideoLinkPreviewSize(
    linkPreview: VideoLinkPreviewObject,
    previewSize: PreviewSize
) {
    updateWebpageLinkPreviewSize(linkPreview, previewSize);
}
